import React from 'react';
import LoginForm from '../features/authentication/components/LoginForm';

const Login = () => <LoginForm />;

export default Login;
